import ControlType from './ControlType';
import FormControl from './FormControl';

export default class TextInput extends FormControl<HTMLInputElement> {
  type = ControlType.Text;
}
